// ajaxifyCollection = function (settings) {
// 	var linkParent = '.pagination-content';
// 	var parentContainer = '[data-infinite="true"]';
// 	var endlessScrollContainer = '[data-infinite="true"]';
// 	var endlessOffset = 600;
// 	var ajaxinateContainer = '.Ajaxinate';
// 	var ajaxinateLink = '.pagination__item--next-page';
// 	var fade = 'fast';
// 	var textChange = 'Loading';
// 	var loader = '.gant-loading-spinner--wrapper';
// 	var linkElem;
// 	var contentContainer;
// 	var pageNumber;
// 	var pageType;
// 	var action;
// 	var moreURL;
// 	var moreURLElement;
// 	var moreURLCheck;
// 	var currentPage;
// 	contentContainer = endlessScrollContainer
// 	var maxPages = $(linkParent).data('pages');

// 	var loadedLastPage = false;
//   var isLoading = false;

// 	$.loadMore = function () {

//     if (isLoading || loadedLastPage) return;

// 		moreURLElement  = document.querySelector('.gant-loading-spinner--wrapper')
// 		if (!moreURLElement) {
// 			return;
// 		}
// 		moreURL = moreURLElement.getAttribute('data-href');;
// 		if (!moreURL) {
// 			return;
// 		}
// 		// Add sort_by=created-descending
// 		const nextURL = new URL(moreURL, window.location.origin);
// 		nextURL.searchParams.set('sort_by', 'created-descending');

// 		moreURL = nextURL.href;
//     	isLoading = true;
// 		$(linkParent).hide();
// 		$(loader).show();

// 		$.ajax({
// 			type: 'GET',
// 			dataType: 'html',
// 			url: moreURL,
// 			success: function (data) {
// 				if (currentPage == maxPages) {
// 					loadedLastPage = true;
// 				}
// 				var filteredData = $(data).find(contentContainer);
// 				var filteredDataProducts = filteredData[0].innerHTML;
// 				var newProdHtml = $(filteredDataProducts);
// 				$(contentContainer).append(newProdHtml).hide().fadeIn(fade);
// 				var newProducts = newProdHtml;
// 				// moreURL = $(data).find(".pagination .pagination-next").attr('href');
// 				let nextMoreURL = $(data).find(".pagination .pagination-next").attr('href');
// 				if (nextMoreURL) {
// 					const nextURL = new URL(
// 						nextMoreURL,
// 						window.location.origin
// 					);

// 					nextURL.searchParams.set(
// 						'sort_by',
// 						'created-descending'
// 					);

// 					moreURL = nextURL.toString();
// 				}
// 				$('.paginate-load-more-wrap').html($(data).find('.paginate-load-more-wrap').html())
// 				$(".pagination").html($(data).find(".pagination").html());
// 				if (typeof wishlistData.init === "function") {
// 					setTimeout(() => {
// 						wishlistData.init();
// 					}, 800);
// 				}
// 				collectionGetVariations(settings, newProducts);
// 				$(linkParent).hide();

// 				$(loader).hide();
//         isLoading = false;
// 			},
// 			timeout: 15000,
// 			error: function (jqXHR, textStatus, errorThrown) {
// 				$(loader).hide();
//         isLoading = false;
// 				if (textStatus === "timeout") {
// 					$(linkElem).text("Load more");
// 					$(linkElem).css('opacity', 1);
// 				}
// 			}
// 		});
// 	};

// 	const targetElement = document.querySelector('.paginate-load-more-wrap');
// 	const observer = new IntersectionObserver((entries, observer) => {
// 		entries.forEach(entry => {
// 			if (entry.isIntersecting) {
// 				$.loadMore();
// 			}
// 		});
// 	}, {
// 		root: null,
// 		rootMargin: '0px',
// 		threshold: 1.0
// 	});
// 	if (targetElement) {
// 		observer.observe(targetElement);
// 	}
// };


ajaxifyCollection = function (settings) {
  var linkParent = '.pagination-content';
  var parentContainer = '[data-infinite="true"]';
  var endlessScrollContainer = '[data-infinite="true"]';
  var endlessOffset = 600;
  var ajaxinateContainer = '.Ajaxinate';
  var ajaxinateLink = '.pagination__item--next-page';
  var fade = 'fast';
  var textChange = 'Loading';
  var loader = '.gant-loading-spinner--wrapper';

  var linkElem;
  var contentContainer;
  var pageNumber;
  var pageType;
  var action;
  var currentPage;

  contentContainer = endlessScrollContainer;

  var maxPages = $(linkParent).data('pages');

  var loadedLastPage = false;
  var isLoading = false;

  $.loadMore = function () {
    // Prevent multiple requests
    if (isLoading || loadedLastPage) {
      return;
    }

    /*
     * Find the current load-more URL
     */
    var moreURLElement = document.querySelector(
      '.gant-loading-spinner--wrapper'
    );

    if (!moreURLElement) {
      return;
    }

    /*
     * Get URL from data-href
     *
     * Example:
     * /collections/new-arrival-men?page=2&section_id=template...
     */
    var moreURL = moreURLElement.getAttribute('data-href');

    if (!moreURL) {
      return;
    }

    /*
     * Convert relative URL to absolute URL
     */
    var nextURL = new URL(
      moreURL,
      window.location.origin
    );

    /*
     * Always force:
     * sort_by=created-descending
     */
    nextURL.searchParams.set(
      'sort_by',
      'created-descending'
    );

    moreURL = nextURL.toString();

    console.log(
      'Infinite scroll request:',
      moreURL
    );

    isLoading = true;

    $(linkParent).hide();
    $(loader).show();

    /*
     * AJAX request
     */
    $.ajax({
      type: 'GET',
      dataType: 'html',
      url: moreURL,

      success: function (data) {
        /*
         * Check if last page
         */
        if (currentPage == maxPages) {
          loadedLastPage = true;
        }

        /*
         * Find product container from Shopify response
         */
        var filteredData = $(data).find(
          contentContainer
        );

        /*
         * Safety check
         */
        if (!filteredData.length) {
          console.warn(
            'Infinite scroll: product container not found'
          );

          $(loader).hide();
          isLoading = false;

          return;
        }

        /*
         * Extract products
         */
        var filteredDataProducts =
          filteredData[0].innerHTML;

        var newProdHtml =
          $(filteredDataProducts);

        /*
         * Append new products
         */
        $(contentContainer)
          .append(newProdHtml)
          .hide()
          .fadeIn(fade);

        var newProducts = newProdHtml;

        /*
         * Get the new load-more wrapper from Shopify response
         */
        var newLoadMoreHTML = $(data)
          .find('.paginate-load-more-wrap')
          .html();

        if (newLoadMoreHTML) {
          $('.paginate-load-more-wrap')
            .html(newLoadMoreHTML);
        }

        /*
         * Replace pagination HTML
         */
        var newPaginationHTML = $(data)
          .find('.pagination')
          .html();

        if (newPaginationHTML) {
          $('.pagination')
            .html(newPaginationHTML);
        }

        /*
         * Reinitialize wishlist
         */
        if (
          typeof wishlistData !== 'undefined' &&
          typeof wishlistData.init === 'function'
        ) {
          setTimeout(function () {
            wishlistData.init();
          }, 800);
        }

        /*
         * Get product variations
         */
        collectionGetVariations(
          settings,
          newProducts
        );

        /*
         * Hide loader
         */
        $(linkParent).hide();
        $(loader).hide();

        /*
         * Allow next request
         */
        isLoading = false;
      },

      timeout: 15000,

      error: function (
        jqXHR,
        textStatus,
        errorThrown
      ) {
        console.error(
          'Infinite scroll AJAX error:',
          textStatus,
          errorThrown
        );

        $(loader).hide();

        isLoading = false;

        if (textStatus === 'timeout') {
          if (linkElem) {
            $(linkElem).text('Load more');
            $(linkElem).css(
              'opacity',
              1
            );
          }
        }
      }
    });
  };


  /*
   * Infinite scroll observer
   */
  var targetElement = document.querySelector(
    '.paginate-load-more-wrap'
  );

  /*
   * Stop if load-more wrapper doesn't exist
   */
  if (!targetElement) {
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          $.loadMore();
        }
      });
    },
    {
      root: null,

      /*
       * Start loading 600px before
       * the user reaches the bottom
       */
      rootMargin: endlessOffset + 'px 0px',

      threshold: 0
    }
  );

  observer.observe(targetElement);
};